import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css, injectGlobal } from 'styled-components';
import { rgba } from 'polished';
import Modal from 'react-modal';

import { ImageReferenceSlideshow } from '../'

import { media } from '../../styles/utils';
import { green, greenSecondary } from '../../styles/colors';
import { hoverState, padding, bgImage } from '../../styles/global';

class SlideshowModal extends Component {

    state = {
        modalVisible: false
    }

    toggleModal = () => {
        this.setState({
            modalVisible: !this.state.modalVisible
        })
    }
    
    render() {
        const { modalVisible } = this.state;
        const { images, placeholder, imageOverride } = this.props;

        const customStyles = {
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                padding: 20,
                border: 0,
                backgroundColor: 'transparent',
                transition: 'opacity 0.5s ease'
            },
            overlay: {
                backgroundColor: `${rgba('black', 0.2)}`,
                zIndex: 10,
                transition: 'opacity 0.5s ease'
            }
        };

        return (
            <React.Fragment>

                <ClickDetector
                    onClick={this.toggleModal}
                >
                    {placeholder}
                </ClickDetector>
        
                <Modal
                    isOpen={this.state.modalVisible}
                    style={customStyles}
                >
                    <ImageReferenceSlideshow
                        images={images}
                        inModal={true}
                        onSlideChange={this.updateActiveSlide}
                        {...this.props}
                    />

                    <Close
                        onClick={this.toggleModal}
                    >
                        Close
                    </Close>
                </Modal>
            </React.Fragment>
        )
    }
}


const ClickDetector = styled.div`
    cursor: zoom-in;
    
    > * {
        pointer-events: none
    }
`

const Close = styled.div`
    position: absolute;
    top: 40px;
    right: 40px;
    color: white;
    ${hoverState}
    cursor: pointer;

    ${media.phone`
        top: 32px;
    `}
`

export default SlideshowModal;


// WEBPACK FOOTER //
// ./client/components/SlideshowModal/SlideshowModal.js